import alt from 'components/Dispatcher';

class SearchInputActions {
  constructor() {
    this.generateActions('clearSearchInputValue', 'updateSearchTerm');
  }
}

export default alt.createActions(SearchInputActions);
